import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq, gt } from 'ember-truth-helpers';
import UiHeader from 'garaje/components/ui/header';

interface GridHeaderSignature {
  Args: {
    gridIndex: number;
    gridName: string;
    gridDescription: string;
    toggleUpsellModal: (event: MouseEvent) => void;
  };
}

export default <template>
  <div class="flex justify-between items-center">
    <div class="{{if (eq @gridIndex 0) 'mb-10' 'mt-10'}}">
      <UiHeader class="mb-1">{{@gridName}}</UiHeader>
      <p>{{@gridDescription}}</p>
      {{#if (eq @gridIndex 0)}}
        <p class="mb-0">{{svgJar "megaphone" class="-mb-1 mr-1"}}
          Can't see or customize what you need?
          <a href="mailto:custom-admin-roles-feedback@envoy.com">Send us feedback</a></p>
      {{/if}}
    </div>
    {{#if (gt @gridIndex 0)}}
      <button class="btn btn--brand mt-1" {{on "click" @toggleUpsellModal}}>Upgrade</button>
    {{/if}}
  </div>
</template> satisfies TOC<GridHeaderSignature>;
